var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25476 15.7452C1.08175 12.5722 1.08175 7.42777 4.25476 4.25476C7.42777 1.08175 12.5722 1.08175 15.7452 4.25476C18.9183 7.42777 18.9183 12.5722 15.7452 15.7452C12.5722 18.9183 7.42777 18.9183 4.25476 15.7452ZM2.92893 2.92893C-0.976311 6.83418 -0.976311 13.1658 2.92893 17.0711C6.83418 20.9763 13.1658 20.9763 17.0711 17.0711C20.9763 13.1658 20.9763 6.83418 17.0711 2.92893C13.1658 -0.976311 6.83418 -0.976311 2.92893 2.92893ZM7.53763 6.21209C7.17151 5.84597 6.57792 5.84597 6.2118 6.21209C5.84568 6.5782 5.84568 7.1718 6.2118 7.53791L8.67389 10L6.2118 12.4621C5.84568 12.8282 5.84568 13.4218 6.2118 13.7879C6.57791 14.154 7.17151 14.154 7.53762 13.7879L9.99971 11.3258L12.4618 13.7879C12.8279 14.154 13.4215 14.154 13.7876 13.7879C14.1537 13.4218 14.1537 12.8282 13.7876 12.4621L11.3255 10L13.7876 7.53792C14.1537 7.1718 14.1537 6.57821 13.7876 6.2121C13.4215 5.84598 12.8279 5.84598 12.4618 6.21209L9.99971 8.67417L7.53763 6.21209Z",
    fill: "#B90404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/deleteRed.b0700816.svg";
export { ForwardRef as ReactComponent };